import { render, staticRenderFns } from "./DemographyAnalytics.vue?vue&type=template&id=5d27aa1c&"
import script from "./DemographyAnalytics.vue?vue&type=script&lang=js&"
export * from "./DemographyAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports